import React from 'react';
import PropTypes from 'prop-types';

import { ContactPerson } from 'components/common/Elements/Elements';

import classes from '../CancellationsTable.module.scss';

const ContactCell = ({ data }) => {
  const { fullName, email, department } = data;
  return (
    <ContactPerson
      person={fullName}
      email={email}
      role={department}
      personClass={classes.fullName}
    />
  );
};

ContactCell.propTypes = {
  data: PropTypes.object
};

export default ContactCell;
